<template>
    <div>
        <h1>联系方式</h1>
        <!--非编辑状态-->
        <div>
            <span>联系方式</span>
            <span>{{baseInfo.mobilePhone}}</span>
            <span>{{baseInfo.email}}</span>
        </div>


        <!--编辑状态-->
        <div v-if="resumeEditStatus==true">
            <el-form ref="contactForm" :model="contactForm" :rules="rules">
                <el-form-item label="手机号码" prop="mobilePhone">
                    <el-input
                            v-model="contactForm.mobilePhone"
                            placeholder="请输入11位手机号码"
                            maxlength="11">
                    </el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input
                            v-model="contactForm.email"
                            placeholder="请输入电子邮箱"
                            maxlength="30">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" round @click="saveContact()">保存</el-button>
                    <el-button type="primary" round >取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import {saveContact} from '@/api/resume';
    export default {
        name: 'contact',
        props: ['baseInfo'],
        data() {
            return {
                // 简历联系方式表单
                contactForm: {},
                // 简历联系方式表单校验规则
                rules: {
                    mobilePhone: [
                        {required: true, message: '请输入手机号码'},
                        {pattern:/^1[0-9]{10}$/, message: '请输入11位手机号码'}
                    ],
                    email: [
                        {required: true, message: '请输入电子邮箱'},
                        {min: 1, max: 30, message: '请输入有效的电子邮箱'},
                        {pattern:/^([a-z0-9A-Z]+[-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/, message: '请输入有效的电子邮箱'}
                    ]
                },
            }
        },
        computed: {
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            }
        },
        methods: {
            // 保存简历联系方式
            saveContact(){
                this.$refs["contactForm"].validate(valid=>{
                    if(valid) {
                        this.contactForm.id = this.baseInfo.id;
                        saveContact(this.contactForm).then(res=>{

                        }).catch(()=>{
                            this.$message.error("简历联系方式保存失败");
                        })
                    }
                })
            }
        }
    }
</script>